import React from 'react';
import PropTypes from 'prop-types';
import CollapseMenu from './CollapseMenu';
import Brand from './Brand';
import ToggleButton from './ToggleButton';

const Navbar = ({onCreateComplaintClick, onHomeBtnClick, onPreviewComplaintClick, logoUrl}) => {
    const collapseMenuId="menu-collapse";
    return( 
        <nav className="navbar navbar-inverse navbar-fixed-top menu-nav">
            <div className="container-fluid menu-container">
                <div className="col-xs-12 col-sm-5 col-md-4 col-lg-4 menu-head">
                    <div className="navbar-header menu-header">
                        <Brand
                            onBrandClick={onHomeBtnClick}
                            logoUrl={logoUrl} />
                        <ToggleButton collapseMenuId={collapseMenuId}/>
                    </div>
                </div>
                <div
                    className="collapse navbar-collapse menu-collapsed"
                    id={collapseMenuId}>
                    <CollapseMenu
                        onCreateComplaintClick={onCreateComplaintClick}
                        onHomeBtnClick={onHomeBtnClick}
                        onPreviewComplaintClick={onPreviewComplaintClick} />
                </div>
            </div>
        </nav>
    );
};

Navbar.propTypes = {
    onCreateComplaintClick: PropTypes.func.isRequired,
    onHomeBtnClick: PropTypes.func.isRequired,
    onPreviewComplaintClick: PropTypes.func.isRequired,
    logoUrl: PropTypes.string.isRequired
};

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/TopMenu/Navbar.js